import styled from "styled-components";
function WelcomeBlock(){
    return(
        <Block>
            <div className="WelcomeBlockTitle">
                <div className="f-inter ">
                    Vývíjíme webové stránky a aplikace
                </div>
                <div className="img">

                </div>
            </div>
            <Text className="f-inter red-color">
                Vaše přání jsou pro nás prioritou. Snažíme se porozumět vašim potřebám a vytvořit pro vás unikátní řešení, které vám pomohou dosáhnout vašich cílů a uspět v online světě.
            </Text>
        </Block>
    );
}
const Block = styled.div`
  width:800px;
  .WelcomeBlockTitle{
    font-weight: bold;
    font-size:64px;
    padding-bottom:20px;
    @media only screen and (min-width: 500px) and (max-width: 700px){
      font-size:42px;
    }
    @media only screen and (max-width: 499px){
      font-size:32px;
    }
  }
  .red-color{
    color:var(--main-color);
  }
  @media only screen and (max-width: 1099px){
    width:auto;
  }
`;
const Text = styled.div`
  font-size:24px;

  @media only screen and (min-width: 500px) and (max-width: 700px){
    font-size:24px;
  }
  
  @media only screen and (max-width: 499px){
    font-size:18px;
  }
`;

export default WelcomeBlock;